import React, { useMemo } from "react";
import { ElasticProduct, useProductPrice } from "@usereactify/search";

import { useShopify } from "@app/scripts/react-hooks/shopify";
import { ProductCard } from "@app/scripts/react-product/components/ProductCard";

type Props = ReturnType<typeof useProductPrice> & {
  pagePosition: number;
  product: ElasticProduct;
  document: ElasticProduct;
  itemRef: (node?: Element | null) => void;
  handleClick: () => void;
};

export const ResultCardProduct: React.FC<Props> = (props) => {
  const { product } = props;
  const { normaliseElasticProduct } = useShopify();
  const normalised = useMemo(() => normaliseElasticProduct(product), [normaliseElasticProduct, product]);

  return product ? <ProductCard product={normalised} hasQuickAddDrawer={true} quickAddStyle="plp" /> : null;
};
